import { render, staticRenderFns } from "./StripeBridgeAttach.vue?vue&type=template&id=5509b970&scoped=true"
import script from "./StripeBridgeAttach.vue?vue&type=script&lang=js"
export * from "./StripeBridgeAttach.vue?vue&type=script&lang=js"
import style0 from "./StripeBridgeAttach.vue?vue&type=style&index=0&id=5509b970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5509b970",
  null
  
)

export default component.exports